import { createClickableElement } from "./button";

export interface IHamburgerMenuDeps {
	onMenuClick: () => Promise<void>;
}

export function initHamburgerMenu(buttonEl: HTMLElement, deps: IHamburgerMenuDeps) {
	const openClass = "a-hamburger-menu--open";
	const { onMenuClick } = deps;

	const menuButtonComponent = createClickableElement(buttonEl, onMenuClick, { enableOnEnter: true });

	return {
		open: () => buttonEl.classList.add(openClass),
		close: () => buttonEl.classList.remove(openClass),
		toggle: (force?: boolean) => buttonEl.classList.toggle(openClass, force),
		dispose: () => menuButtonComponent.dispose(),
	};
}
